export default function initTagGroups(): void {
    document.querySelectorAll<HTMLElement>( '[data-tag-group]' ).forEach( ( group: HTMLElement ) => {
        const groupName = group.dataset.tagGroup || '';

        if  ( !groupName ) {
            return;
        }

        const children = document.querySelectorAll<HTMLElement>( `[data-tag-parent-group="${groupName}"]` );

        if ( children.length === 0 ) {
            return;
        }

        const input = group.querySelector<HTMLInputElement>( 'input' );

        if ( !input ) {
            return;
        }

        group.addEventListener( 'taggroup:collapse', ( event: CustomEvent ) => {
            children.forEach( ( child: HTMLElement ) => child.classList.add( 'ts-checktags--hidden' ) );
        } );

        input.addEventListener( 'change', () => {
            children.forEach( ( child: HTMLElement ) => {
                child.classList.toggle( 'ts-checktags--hidden' );

                const childInput = child.querySelector<HTMLInputElement>( 'input' );

                if ( !childInput ) {
                    throw new Error( 'failed to find input for tag' );
                }

                if ( !input.checked ) {
                    childInput.checked = false;
                }
            } );
        } );
    } );
}
